import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  avatar: '',
  userName: '',
  email: '',
  authority: [],
  // Garantir que não há referências circulares
  id: null,
  firstname: '',
  lastname: '',
  role: [],
  image_url: '',
};

export const userSlice = createSlice({
  name: 'auth/user',
  initialState,
  reducers: {
    setUser: (_, action) => action.payload,
    userLoggedOut: () => initialState,
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
